import { createContext } from "react";

export const InFrontOfCanvasPortalContext = createContext<{
  el: HTMLElement | null;
  setEl: (el: HTMLElement | null) => void;
}>({
  el: null,
  setEl: () => {},
});
